import * as React from "react";
import ImageTextCtaList, {
    ImageTextCtaListProps
} from "~/components/image-text-cta-list/image-text-cta-list";

export interface IImageTextCtaListViewProps {
    contextModel: ImageTextCtaListProps;
}

class ImageTextCtaListView extends React.PureComponent<IImageTextCtaListViewProps> {
    public render() {
        return <ImageTextCtaList {...this.props.contextModel} />;
    }
}

export default ImageTextCtaListView;
